// Функция для получения всех UTM параметров из URL
const getUTMParameters = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const utmParams = {};

  // Собираем только параметры, начинающиеся с 'utm_'
  urlParams.forEach((value, key) => {
    if (key.startsWith('utm_')) {
      utmParams[key] = value;
    }
  });

  return utmParams;
}

// Функция для добавления UTM параметров к URL
const addUTMParameters = (url, utmParams) => {
  const baseUrl = new URL(url);

  // Добавляем UTM параметры к существующим параметрам
  Object.entries(utmParams).forEach(([key, value]) => {
    baseUrl.searchParams.set(key, value);
  });

  return baseUrl.href;
}

// Основная функция для обработки ссылок
const processLinks = () => {
  const utmParams = getUTMParameters();

  // Если есть UTM параметры, обрабатываем ссылки
  if (Object.keys(utmParams).length > 0) {

    const links = [...document.querySelectorAll('a')];

    links.forEach(link => {
      link.href = addUTMParameters(link.href, utmParams);
    });
  }
}

export default processLinks